const TierTypes = {
  basic: "basic",
  premium: "premium",
  enterprise: "enterprise",
};
export default TierTypes;
